import React, { useState, useRef, useEffect } from "react";
import "./CardSlider.css";
import img from "../../assets/icon/account_circle.png"
import {Image} from 'react-bootstrap'
import { FaStar } from "react-icons/fa";

const images = [
  {
    name: "Name",
    title: "Deep Home Cleaning"
  },
  {
    name: "Name",
    title: "Bathroom Floor Cleaner"
  },
  {
    name: "Name",
    title: "House Cleaning Services"
  },
  {
    name: "Name",
    title: "House Cleaning Services"
  },
  {
    name: "Name",
    title: "House Cleaning Services"
  },
  {
    name: "Name",
    title: "House Cleaning Services"
  },
  {
    name: "Name",
    title: "House Cleaning Services"
  },
];
  


export default function CardSlider() {
   const [activeIndex, setActiveIndex] = useState(1);
  const sliderRef = useRef(null);

  const scrollToIndex = (index) => {
    const slider = sliderRef.current;
    const cardWidth = slider.offsetWidth / 3;
    slider.scrollTo({
      left: cardWidth * (index - 1),
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleScroll = () => {
    const slider = sliderRef.current;
    const cardWidth = slider.offsetWidth / 3;
    const index = Math.round(slider.scrollLeft / cardWidth) + 1;
    setActiveIndex(index);
  };

  // Initial scroll
  useEffect(() => {
    scrollToIndex(activeIndex);
  }, []);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % images.length;
        scrollToIndex(nextIndex === 0 ? 1 : nextIndex);
        return nextIndex === 0 ? 1 : nextIndex;
      });
    }, 5000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  
    return (
        <div className="slider-container-feed"  >
      <div className="slider" ref={sliderRef} onScroll={handleScroll}>
        {images.map((src, index) => (
          <div
            key={index}
            
            className={`card ${index === activeIndex ? "active" : "inactive"}`}
          >
            <Image src={img} className="img-box" />
            <h6 className="text-name-box">{src.name}</h6>
            <p className="text-para-box">{src.title}</p>
            <div className="star-box">
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} className="star" />
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === activeIndex ? "active-dot" : ""}`}
            onClick={() => scrollToIndex(index)}
          />
        ))}
      </div>
    </div>
    );
  };
  